var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M57.136 26.857H22.864a2 2 0 0 0-2 2v39.909a2 2 0 0 0 2 2h34.272a2 2 0 0 0 2-2v-39.91a2 2 0 0 0-2-2m-34.272-2a4 4 0 0 0-4 4v39.909a4 4 0 0 0 4 4h34.272a4 4 0 0 0 4-4v-39.91a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.318 47.402a1 1 0 0 1 1 1v17.727a1 1 0 0 1-2 0V48.402a1 1 0 0 1 1-1M50.864 47.402a1 1 0 0 1 1 1v17.727a1 1 0 1 1-2 0V48.402a1 1 0 0 1 1-1M50.864 36.13a1 1 0 0 1 1 1v6.454a1 1 0 1 1-2 0v-6.455a1 1 0 0 1 1-1M39.59 36.13a1 1 0 0 1 1 1v6.454a1 1 0 1 1-2 0v-6.455a1 1 0 0 1 1-1M28.318 36.13a1 1 0 0 1 1 1v6.454a1 1 0 0 1-2 0v-6.455a1 1 0 0 1 1-1M39.59 47.402a1 1 0 0 1 1 1v17.727a1 1 0 1 1-2 0V48.402a1 1 0 0 1 1-1M34 9.766a1 1 0 0 1 1-1h12.09a1 1 0 1 1 0 2H35a1 1 0 0 1-1-1M16.045 14.584a1 1 0 0 1 1-1h48a1 1 0 1 1 0 2h-48a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;